import { PaymentMethod } from "@stripe/stripe-js";

// Safe for use in CSR
export interface MinimalCard {
  name: string | null;
  brand: string;
  last4: string | null;
  exp_month: number | null;
  exp_year: number | null;
  type: string;
}

export interface Link {
  email: string;
  type: string;
}

export type BiddifyPaymentMethod = MinimalCard | Link;

export const isLink = (paymentMethod: BiddifyPaymentMethod): paymentMethod is Link => {
  return paymentMethod.type === 'link';
}

export const extractLinkDetails = (paymentMethod: any): Link | null => {
  const { link } = paymentMethod;
  if (!link) return null;
  return {
    email: link.email,
    type: paymentMethod.type,
  };
}

export const extractMinimalCardDetails = (
  paymentMethod: PaymentMethod,
): MinimalCard | null => {
  const { card, billing_details } = paymentMethod;

  if (!card) return null;

  return {
    name: billing_details?.name,
    brand: card.brand,
    last4: card.last4 || null,
    exp_month: card.exp_month || null,
    exp_year: card.exp_year || null,
    type: paymentMethod.type,
  };
};


export const sanitizePaymentMethod = (paymentMethod: any): BiddifyPaymentMethod | null => {
  if (paymentMethod.type === 'card') {
    return extractMinimalCardDetails(paymentMethod);
  } else if (paymentMethod.type === 'link') {
    return extractLinkDetails(paymentMethod);
  }
  return null;
}